const headList: any[] = [
  {
    headTitle: "氏名",
    align: "center",
    forSort: "氏名",
  },
  {
    headTitle: "配置換え前施設名",
    align: "center",
    forSort: "配置換え前施設名",
  },
  {
    headTitle: "配置換え後施設名",
    align: "center",
    forSort: "配置換え後施設名",
  },
  {
    headTitle: "配置換え年月日",
    align: "center",
    forSort: "配置換え年月日",
  },
  {
    headTitle: "処理状況",
    align: "center",
    forSort: "処理状況",
  },
  {
    headTitle: "異動・複帰登録",
    align: "center",
    forSort: "異動・複帰登録",
  },
];

export { headList };
